module.exports = __webpack_public_path__ + "static/media/wd_page_area01_img_cn.07e44f14.png";